module.exports = __webpack_public_path__ + "static/img/WZ.092b19f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bankInfoBg/WZ.png
// module id = ceT7
// module chunks = 70